import React from "react";
import { Table, Button, Badge, Alert } from "react-bootstrap";
import {
  IconEdit,
  // IconTrash,
  IconEye,
  IconCheck,
  IconX,
} from "@tabler/icons-react";
import { formatNumber, getContrastColor } from "utils/utils";

const PurchaseOrderTable = ({
  purchaseOrders,
  onEdit,
  // onDelete,
  onView,
  onApprove,
  onReject,
  Pagination,
}) => {
  const getStatusBadgeVariant = (status) => {
    switch (status?.toLowerCase()) {
      case "pending":
        return "warning";
      case "ordered":
        return "info";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  };

  // const formatCurrency = (amount) => {
  //   return new Intl.NumberFormat("id-ID", {
  //     style: "currency",
  //     currency: "IDR",
  //   }).format(amount || 0);
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return new Date(dateString).toLocaleDateString("id-ID");
  };

  if (purchaseOrders.error) {
    return (
      <Alert variant="danger">
        <strong>Error loading purchase orders:</strong> {purchaseOrders.error}
      </Alert>
    );
  }

  if (!purchaseOrders.data || purchaseOrders.data.length === 0) {
    return (
      <Alert variant="info">
        No purchase orders found. Create your first purchase order to get
        started.
      </Alert>
    );
  }

  return (
    <div>
      <div style={{ overflowX: "auto" }}>
        <Table responsive hover>
          <thead className="bg-primary text-white">
            <tr>
              <th>Order Number</th>
              <th>Warehouse</th>
              <th>Requester</th>
              <th>Order Date</th>
              <th>Status</th>
              <th className="text-end">Total Amount (Rp)</th>
              <th>Items Count</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {purchaseOrders.data.map((order) => (
              <tr key={order.id}>
                <td>
                  <strong>{order.po_number}</strong> <br />
                  <small className="text-xs text-seconday">
                    To: {order.supplier?.name || "-"}{" "}
                  </small>
                </td>
                <td>{order.warehouse?.name || "-"}</td>
                <td>{order.requester?.name || "-"}</td>
                <td>{formatDate(order.created_at)}</td>
                <td>
                  <Badge
                    bg={getStatusBadgeVariant(order.status)}
                    style={{
                      color: getContrastColor(
                        getStatusBadgeVariant(order.status)
                      ),
                    }}
                  >
                    {order.status || "Unknown"}
                  </Badge>
                </td>
                <td className="text-end">{formatNumber(order.total_amount)}</td>
                <td>{order.items?.length || 0} items</td>
                <td>
                  <div className="d-flex gap-1">
                    {onView && (
                      <Button
                        variant="outline-info"
                        onClick={() => onView(order)}
                        title="View Details"
                      >
                        <IconEye />
                      </Button>
                    )}

                    {onEdit && (order.status?.toLowerCase() !== "ordered" && order.status?.toLowerCase() !== "completed") && (
                      <Button
                        variant="outline-primary"
                        onClick={() => onEdit(order)}
                        title="Edit"
                      >
                        <IconEdit />
                      </Button>
                    )}

                    {onApprove && order.status?.toLowerCase() === "pending" && (
                      <Button
                        variant="outline-success"
                        onClick={() => onApprove(order)}
                        title="Approve Purchase Order"
                      >
                        <IconCheck />
                      </Button>
                    )}
                    {onReject && order.status?.toLowerCase() === "pending" && (
                      <Button
                        variant="outline-warning"
                        onClick={() => onReject(order)}
                        title="Reject Purchase Order"
                      >
                        <IconX />
                      </Button>
                    )}
                    {/* {onDelete && (
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => onDelete(order)}
                        title="Delete"
                      >
                        <IconTrash size={16} />
                      </Button>
                    )} */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {Pagination && (
        <div className="d-flex justify-content-center mt-3">{Pagination}</div>
      )}
    </div>
  );
};

export default PurchaseOrderTable;
